import React, { useEffect, useRef, useState } from 'react';
import useUploadFile from '../../hooks/upload-file.hook';
import { ENVIRONMENT_CONSTANT } from '../../constants/env.constant';
import FieldError from '../fields-errors/field-error';
import { Form } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

function UploadImage({setImage}) {
    const fileInputRef = useRef(null);
    const { file, fileError, fileProperties, fileUploadLoader, checkIsValidImage } = useUploadFile(null);
    const { watch } = useFormContext();
    const watchFields = watch();

    useEffect(() => {
        if (fileProperties?.image_location) {
            setImage(fileProperties?.image_location);
        }
    }, [fileProperties])
    
    return (
            <div className='col-xxl-6 col-md-12'>
                <Form.Label className='text-bold text-black'>Banner Image</Form.Label>
                <p className='f-12-small text-muted'>Images should be 1920px x 1080px</p>
                <div className='upload-image-container' style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '8px',
                    padding: '30px',
                    textAlign: 'center',
                    minHeight: '250px',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}>

                    {
                        watchFields?.banner_image_url ?
                            <img src={`${ENVIRONMENT_CONSTANT.LOGO_BASE_URL}${watchFields?.banner_image_url}`} className='img-fluid organization-logo mb-2' /> :
                            <i className="text-primary fa-solid fa-rocket f-25 mb-3"></i>
                    }
                    <p className='text-muted mb-2'>Click to browse your computer</p>
                    <button
                    disabled={fileUploadLoader}
                        onClick={() => {
                            fileInputRef?.current?.click();
                        }}
                        type='button'
                        className={`btn btn-primary mb-3 position-relative ${fileUploadLoader ? 'button--loading' : ''}`}
                    >
                        {watchFields?.banner_image_url ? 'Change Image' : 'Upload Image'}
                    </button>
                    <input type='file'
                    onChange={(e) => checkIsValidImage(e, true)}
                     ref={fileInputRef} className='d-none' accept='.png, .jpeg, .jpg' />
                    {fileError ? <FieldError message={fileError} /> : ''}
                </div>
            </div>
    );
}

export default UploadImage;